import { Button } from "@gigpro/ui/Button";
import { Dialog, DialogFooter, DialogTitle } from "@gigpro/ui/Dialog";

type InvoicedCustomerIdErrorDialogProps = {
  open: boolean;
  message: string;
  onClose: () => void;
  /** Radix returns focus to whatever opened the dialog; the caller says where it should land instead. */
  onCloseAutoFocus: (event: Event) => void;
};

export const InvoicedCustomerIdErrorDialog: React.FC<InvoicedCustomerIdErrorDialogProps> = ({
  open,
  message,
  onClose,
  onCloseAutoFocus,
}) => (
  <Dialog open={open} onClose={onClose} onCloseAutoFocus={onCloseAutoFocus} bottomSheet>
    {/* OK is the one way out (Escape aside), so the title drops its X. */}
    <DialogTitle hideCloseButton>Couldn't save Invoiced.com customer ID</DialogTitle>
    <p className="text-wrap">{message}</p>
    <DialogFooter>
      <Button variant="contained" className="w-full" onClick={onClose}>
        OK
      </Button>
    </DialogFooter>
  </Dialog>
);
